import { render, staticRenderFns } from "./VehicleNumberInput.vue?vue&type=template&id=01632043&scoped=true"
import script from "./VehicleNumberInput.vue?vue&type=script&lang=js"
export * from "./VehicleNumberInput.vue?vue&type=script&lang=js"
import style0 from "./VehicleNumberInput.vue?vue&type=style&index=0&id=01632043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01632043",
  null
  
)

export default component.exports